var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "url(#pattern0_167_416)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_167_416",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_167_416",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_167_416",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB8ElEQVR4nO2YTStFURSGH983kRQTpKSkJGUgE2XATzA1NLj5GMlf8BeMzfwDDGTiY3AjAxlISUoScVHysXVqnbqd9nb2ufdcZ8t+6x2dvdZ63/2xTi3w8PDw8PDQIwcsAofAM6B+mc9Se1G0JEI3cJSBaGVgoKXLVnwjcOyAaKUxEWiLxYIDYpWB8zYGDh0QqgzctzGw5YBQZeAmlphy7B2cAjMkRK0EXWQo/AqYA+qSCI8uDnrwMnD/i8LvpWa0/1sZMR1XO7AKvFZR+BuwBnT+cK1jUfriJzTfe6TIe4rCP4ENoE9TbwzYKVlrbSDkNjCsWTcoRSsVvw2MaPIPSP6vyPrEBpTs9prhdz4O7JYhPPjfTGrydcpVfTPElWUg5IskbzPc0RML4Wfyxmoi8S3ACvAUE1+RgZB3Uiynab2zwLUm5hZYAuojMQ3SKm8sa6diIOSloU83i8EHoCin1hpZE5xAcBLnCWumaiBkAZjW5OoQRjEtMaoMVsVAaUcZ/SH3UAqdKxaqQn6JyP6SnL3SxT5SyB8LlRKDNrguNLVE5bKBajEWWQtU3gDZ77LyV4g//IiLDohUBj7aGDhwQKgycO+vD7byNgaaHJuLKmHBdrTo4nC3kGS4G6JRZpF7GT3sotTOJ9l5Dw8PD4//hW9PcVQiDOoB9wAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.f7d5467c93f6b39d283d32ea98b145a1.svg";
export { ForwardRef as ReactComponent };